module.exports = __webpack_public_path__ + "static/img/20001 (2).3aab508.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20001 (2).webp
// module id = BXfm
// module chunks = 14